import request from "@/utils/request";
const projectName = "/api/blade-platform";
export const list = params => {
    return request({
        url: `${projectName}/platformAlumniShieldManage/list`,
        method: "post",
        data: params
    });
};

export const getAutoShieldConfigList = () => {
    return request({
        url: `${projectName}/platformalumniautoshieldconfig/getAutoShieldConfigList`,
        method: "get"
    });
};
export const updateAutoShieldConfig = params => {
    return request({
        url: `${projectName}/platformalumniautoshieldconfig/updateAutoShieldConfig`,
        method: "post",
        data: params
    });
};
export const getActionTypeList = () => {
    return request({
        url: `${projectName}/platformalumniword/getActionTypeList`,
        method: "get"
    });
};
export const selectCampusNameAndId = () => {
    return request({
        url: `${projectName}/platformalumniword/selectCampusNameAndId`,
        method: "get"
    });
};

export const shield = params => {
    return request({
        url: `${projectName}/platformalumniaction/shield`,
        method: "post",
        data: params
    });
};

export const getReportReasonList = () => {
    return request({
        url: `${projectName}/platformalumnireportreasonconfig/getReportReasonList`,
        method: "get"
    });
};
